
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fXbFR", function(module, exports) {

$parcel$export(module.exports, "usePopupDwellTime", () => $d2d9cd8fe7c899bb$export$15dda63faa44a0df);

var $gwFzn = parcelRequire("gwFzn");

var $4PxT5 = parcelRequire("4PxT5");
const $d2d9cd8fe7c899bb$export$15dda63faa44a0df = (ref, interval = 500)=>{
    const isOnScreen = (0, $4PxT5.useOnScreen)(ref);
    const dwellTimeRef = (0, $gwFzn.useRef)(0);
    (0, $gwFzn.useEffect)(()=>{
        const incremental = setInterval(()=>{
            if (isOnScreen) dwellTimeRef.current += interval;
        }, interval);
        return ()=>{
            clearInterval(incremental);
        };
    }, [
        isOnScreen,
        interval
    ]);
    const getDwellTime = ()=>dwellTimeRef.current;
    return {
        getDwellTime: getDwellTime
    };
};

});
parcelRegister("4PxT5", function(module, exports) {

$parcel$export(module.exports, "useOnScreen", () => $944e21aa736984a5$export$edb9b52ab3f1abbb);

var $gwFzn = parcelRequire("gwFzn");
const $944e21aa736984a5$export$edb9b52ab3f1abbb = (ref)=>{
    const [isIntersecting, setIntersecting] = (0, $gwFzn.useState)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (!ref.current) return;
        const observer = new IntersectionObserver(([entry])=>setIntersecting(entry.isIntersecting));
        if (ref.current) observer.observe(ref.current);
        return ()=>{
            if (observer) observer.disconnect();
        };
    });
    return isIntersecting;
};

});


parcelRegister("au4KV", function(module, exports) {

$parcel$export(module.exports, "AIStreamLoading", () => $fe7ceaa3509ef4fa$export$47a62cbf3ee79fef);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $igbBp = parcelRequire("igbBp");
const $fe7ceaa3509ef4fa$var$styles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle'
});
const $fe7ceaa3509ef4fa$var$i18n = (0, $2nPZH.defineMessages)({
    generatingSummaryText: {
        id: "ai-stream-loading.title",
        defaultMessage: "Atlassian Intelligence is working..."
    },
    generatingSummaryAnimationAlt: {
        id: "ai-stream-loading.generation-animation",
        defaultMessage: "Generating"
    }
});
const $fe7ceaa3509ef4fa$export$47a62cbf3ee79fef = ({ padding: padding = 'space.300' })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        padding: padding,
        xcss: $fe7ceaa3509ef4fa$var$styles,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
            alignBlock: "center",
            space: "space.025",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $igbBp.GeneratingStreamAnimation), {
                    alt: formatMessage($fe7ceaa3509ef4fa$var$i18n.generatingSummaryAnimationAlt)
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...$fe7ceaa3509ef4fa$var$i18n.generatingSummaryText
                })
            ]
        })
    });
};

});
parcelRegister("igbBp", function(module, exports) {

$parcel$export(module.exports, "GeneratingStreamAnimation", () => $dd45fdb3e38904f6$export$3709887a1be0e305);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $dd45fdb3e38904f6$export$3709887a1be0e305 = ({ alt: alt })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("title", {
                children: alt
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                cx: "5.5",
                cy: "12.5",
                r: "1.5",
                fill: "#0C66E4",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                cx: "11.5",
                cy: "10.5",
                r: "1.5",
                fill: "#1D7AFC",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.2s"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                cx: "17.5",
                cy: "12.5",
                r: "1.5",
                fill: "#388BFF",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.4s"
                })
            })
        ]
    });
};

});


parcelRegister("gWF6I", function(module, exports) {

$parcel$export(module.exports, "RelayEnvironmentProvider", () => $8122506f239babd4$export$43b1f3e917d65526);
$parcel$export(module.exports, "ConditionalRelayEnvironmentProvider", () => $8122506f239babd4$export$2f6292af3d34630d);
$parcel$export(module.exports, "useRelayEnvironmentProvider", () => $8122506f239babd4$export$e237a628f59c9f4e);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6hqbZ = parcelRequire("6hqbZ");

var $lan9D = parcelRequire("lan9D");

var $3tMMZ = parcelRequire("3tMMZ");
const $8122506f239babd4$var$environment = new (0, $lan9D.Environment)((0, $3tMMZ.getDefaultRelayEnvironmentConfig)({}));
const $8122506f239babd4$export$43b1f3e917d65526 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6hqbZ.RelayEnvironmentProvider), {
        environment: $8122506f239babd4$var$environment,
        children: children
    });
};
const $8122506f239babd4$export$2f6292af3d34630d = ({ children: children })=>{
    const isRelayPresent = (0, $gwFzn.useContext)((0, $6hqbZ.ReactRelayContext));
    if (isRelayPresent) return children;
    return /*#__PURE__*/ (0, $7UHDa.jsx)($8122506f239babd4$export$43b1f3e917d65526, {
        children: children
    });
};
function $8122506f239babd4$export$e237a628f59c9f4e() {
    const environment = (0, $6hqbZ.useRelayEnvironment)();
    return (0, $gwFzn.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}

});
parcelRegister("3tMMZ", function(module, exports) {

$parcel$export(module.exports, "getDefaultRelayEnvironmentConfig", () => $887e63c8434f65c2$export$6c790f07f4ef6a59);

var $lan9D = parcelRequire("lan9D");

var $8aLmh = parcelRequire("8aLmh");

var $f2OFx = parcelRequire("f2OFx");

var $7z5rG = parcelRequire("7z5rG");

var $iTyoD = parcelRequire("iTyoD");

var $1b0Xp = parcelRequire("1b0Xp");
const $887e63c8434f65c2$var$createStore = (source, options)=>{
    (0, $lan9D.RelayFeatureFlags).ENABLE_RELAY_RESOLVERS = true;
    return new (0, (/*@__PURE__*/$parcel$interopDefault($8aLmh)))(source, options);
};
const $887e63c8434f65c2$export$6c790f07f4ef6a59 = ({ log: log, requiredFieldLogger: requiredFieldLogger, network: network })=>({
        configName: 'Atlassian Graphql Gateway',
        network: network || (0, $iTyoD.network),
        store: $887e63c8434f65c2$var$createStore(new (0, $lan9D.RecordSource)(), {
            log: log ?? undefined,
            getDataID: (0, $f2OFx.default)
        }),
        log: log,
        relayFieldLogger: requiredFieldLogger,
        getDataID: (0, $f2OFx.default),
        scheduler: (0, $1b0Xp.default),
        missingFieldHandlers: (0, $7z5rG.default)
    });

});
parcelRegister("f2OFx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1b075e40986c7a5$export$2e2bcd8739ae039);

var $dh538 = parcelRequire("dh538");

var $94DPb = parcelRequire("94DPb");
const $c1b075e40986c7a5$var$idTypeMap = new Map();
function $c1b075e40986c7a5$export$2e2bcd8739ae039(fieldValue, typeName) {
    const { id: id } = fieldValue;
    if (id == null) return undefined;
    if ((0, $dh538.fg)('platform_log_relay_duplicate_identifiers')) {
        const idString = String(id);
        if ($c1b075e40986c7a5$var$idTypeMap.has(idString)) {
            const entry = $c1b075e40986c7a5$var$idTypeMap.get(idString);
            if (entry) {
                const { typeName: existingTypeName, hasLoggedConflict: hasLoggedConflict } = entry;
                if (existingTypeName !== typeName && !hasLoggedConflict) {
                    (0, $94DPb.safeWarnWithoutCustomerData)('relaydataid.generator', `RelayDataID: conflicting type names for the same ID: ${idString} with type names: ${existingTypeName} and ${typeName}.`, {
                        id: idString,
                        types: `${existingTypeName}, ${typeName}`
                    });
                    entry.hasLoggedConflict = true;
                }
            }
        } else $c1b075e40986c7a5$var$idTypeMap.set(idString, {
            typeName: typeName,
            hasLoggedConflict: false
        });
    }
    return `${String(id)}:::::${typeName}`;
}

});
parcelRegister("94DPb", function(module, exports) {

$parcel$export(module.exports, "safeWarnWithoutCustomerData", () => $89103c584b545818$export$b8c037155fd57aaf);
const $89103c584b545818$var$defaultOptions = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json, text/javascript, */*'
    }
};
const $89103c584b545818$var$isProduction = ()=>true;
const $89103c584b545818$var$MAX_REQUESTS_PER_INTERVAL = 5;
const $89103c584b545818$var$INTERVAL_MS = 1000;
let $89103c584b545818$var$requestQueue = [];
let $89103c584b545818$var$isProcessingQueue = false;
const $89103c584b545818$var$processQueue = ()=>{
    if ($89103c584b545818$var$isProcessingQueue) return;
    $89103c584b545818$var$isProcessingQueue = true;
    const processNextBatch = ()=>{
        if ($89103c584b545818$var$requestQueue.length === 0) {
            $89103c584b545818$var$isProcessingQueue = false;
            return;
        }
        const batch = $89103c584b545818$var$requestQueue.splice(0, $89103c584b545818$var$MAX_REQUESTS_PER_INTERVAL);
        batch.forEach(({ body: body, endpoint: endpoint })=>{
            fetch(endpoint, {
                ...$89103c584b545818$var$defaultOptions,
                method: 'POST',
                body: body
            });
        });
        setTimeout(processNextBatch, $89103c584b545818$var$INTERVAL_MS);
    };
    processNextBatch();
};
const $89103c584b545818$var$sendToServerBatched = (body, endpoint)=>{
    $89103c584b545818$var$requestQueue.push({
        body: body,
        endpoint: endpoint
    });
    // Start processing the logging queue if not already started
    $89103c584b545818$var$processQueue();
};
const $89103c584b545818$var$sendToConsole = (body, endpoint, level, message, eventType, event)=>{
    // eslint-disable-next-line no-console
    console[level]('%c%s %c(POST %s)\n%cMessage\n%c%s\n\n%cEvent body\n%c%s\n\n%cException object and Stack trace (expand to jump to source)\n', 'font-size: 14px; font-weight: bold;', level.toUpperCase(), 'font-size: 10px; font-family: monospace;', endpoint, 'font-family: sans-serif; font-weight: bold; font-size: 12px', 'font-family: sans-serif; font-weight: initial;', message, 'font-family: sans-serif; font-weight: bold;', 'font-family: monospace; font-weight: initial;', body, 'font-family: sans-serif; font-size: 12px; font-weight: bold;', event);
    const currentWindow = window;
    if (!$89103c584b545818$var$isProduction() && currentWindow.Cypress) {
        if (!currentWindow.cypressSafeErrorsLog) currentWindow.cypressSafeErrorsLog = [];
        currentWindow.cypressSafeErrorsLog.push({
            body: body,
            endpoint: endpoint,
            level: level,
            message: message
        });
    }
    if (eventType !== 'object') {
        const errorMessage = `Invalid log API usage: expected event of type 'object', but was ${eventType}`;
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }
    if (typeof body !== 'string') {
        const errorMessage = `Invalid log API usage: expected event of type 'string', but was ${eventType}; message will be replaced by: ${String(message)}`;
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }
    return Promise.resolve();
};
const $89103c584b545818$var$transformData = (location, message, event)=>{
    return {
        sentFrom: location,
        message: String(message),
        event: event,
        buildKey: window?.BUILD_KEY,
        logTime: new Date().toISOString()
    };
};
const $89103c584b545818$var$sendData = (level, location, message, event = {})=>{
    const data = $89103c584b545818$var$transformData(location, message, event);
    const body = JSON.stringify(data);
    const endpoint = `/rest/internal/2/log/safe/${level}`;
    if ($89103c584b545818$var$isProduction()) return $89103c584b545818$var$sendToServerBatched(body, endpoint);
    return $89103c584b545818$var$sendToConsole(body, endpoint, level, message, typeof event, event);
};
const $89103c584b545818$export$b8c037155fd57aaf = (location, message, event)=>{
    $89103c584b545818$var$sendData('warn', location, message, event);
};

});


parcelRegister("7z5rG", function(module, exports) {

$parcel$export(module.exports, "default", () => $a69540a1adc2255f$export$2e2bcd8739ae039);

var $pCS7V = parcelRequire("pCS7V");

var $f2OFx = parcelRequire("f2OFx");
const $a69540a1adc2255f$var$isCustomFilter = (filterId)=>/^\d+$/.test(filterId);
const $a69540a1adc2255f$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $a69540a1adc2255f$export$77232ec02db7a24a = {
    handle: (field, record, argValues)=>{
        // https://relay.dev/docs/guided-tour/reusing-cached-data/filling-in-missing-data/
        // This lets relay know that a query of
        // JiraQuery.filter(id: ID!)
        // can return:
        //   - a JiraCustomFilter object
        //   - a JiraSystemFilter object
        // determined by the type encoded within the id field (which is an ARI type).
        // By providing the id that relay would refer to those objects by, it is able to check it's
        // store to see if they are already fetched, and avoid refetching them if it is unnecessary
        if (record != null && record.getType() === 'JiraQuery' && field.name === 'filter' && argValues.id != null) {
            const { id: id } = argValues;
            const filterId = (0, $pCS7V.JiraFilterAri).parse(id).filterId;
            if ($a69540a1adc2255f$var$isCustomFilter(filterId)) return (0, $f2OFx.default)({
                id: id
            }, 'JiraCustomFilter');
            if ($a69540a1adc2255f$var$isSystemFilter(filterId)) return (0, $f2OFx.default)({
                id: id
            }, 'JiraSystemFilter');
            return undefined;
        }
        return undefined;
    },
    kind: 'linked'
};
const $a69540a1adc2255f$var$MissingFieldHandlers = [
    $a69540a1adc2255f$export$77232ec02db7a24a
];
var $a69540a1adc2255f$export$2e2bcd8739ae039 = $a69540a1adc2255f$var$MissingFieldHandlers;

});

parcelRegister("iTyoD", function(module, exports) {

$parcel$export(module.exports, "network", () => $185542a16deb61ee$export$21fcfd9d5c6ebbd4);

var $lan9D = parcelRequire("lan9D");

var $2gQQV = parcelRequire("2gQQV");

var $jynRP = parcelRequire("jynRP");
function $185542a16deb61ee$var$fetchQuery(request, variables, cacheConfig) {
    const endpoint = (0, $2gQQV.getAggEndpoint)(request, cacheConfig);
    const body = (0, $2gQQV.getRequestBody)(request, variables);
    return fetch(endpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            // Add authentication and other headers here
            'content-type': 'application/json',
            'X-ExperimentalApi': (0, $jynRP.RelayExperimentalApis).join(',')
        },
        body: body
    }).then((response)=>{
        return response.json();
    });
}
const $185542a16deb61ee$export$21fcfd9d5c6ebbd4 = (0, $lan9D.Network).create($185542a16deb61ee$var$fetchQuery);

});
parcelRegister("2gQQV", function(module, exports) {

$parcel$export(module.exports, "getAggEndpoint", () => $00d790897fd8fcbc$export$fd126d8de571b77d);
$parcel$export(module.exports, "getRequestBody", () => $00d790897fd8fcbc$export$55bce18df99af758);

var $3mTvL = parcelRequire("3mTvL");
const $00d790897fd8fcbc$var$branchSlug = typeof $3mTvL !== 'undefined' && $3mTvL.env ? undefined : undefined;
const $00d790897fd8fcbc$var$aggPathname = `/gateway/api/graphql${$00d790897fd8fcbc$var$branchSlug ? `/${$00d790897fd8fcbc$var$branchSlug}/graphql` : ''}`;
const $00d790897fd8fcbc$export$fd126d8de571b77d = (request, cacheConfig = {})=>{
    let endpoint = $00d790897fd8fcbc$var$aggPathname;
    if (cacheConfig.metadata?.META_SLOW_ENDPOINT) endpoint = `${endpoint}/slow`;
    if (request.id != null) endpoint = `${endpoint}/pq/${request.id}`;
    return `${endpoint}?operation=${request.name}`;
};
const $00d790897fd8fcbc$export$55bce18df99af758 = (request, variables)=>{
    const requestBody = {
        operationName: request.name,
        variables: variables
    };
    return JSON.stringify(requestBody);
};

});

parcelRegister("jynRP", function(module, exports) {

$parcel$export(module.exports, "RelayExperimentalApis", () => $b7af7e3cbaf72c79$export$ebe3a775ce3053a5);
// Please add your Experimental API name below
// You do not need to wait for approval to add to this list
const $b7af7e3cbaf72c79$export$ebe3a775ce3053a5 = [
    'ariGraph',
    'boardCardMove',
    'deleteCard',
    'JiraJqlBuilder',
    'SoftwareCardTypeTransitions',
    'jira-releases-v0',
    'JiraDevOps',
    'JiraDevOpsProviders',
    'createCustomFilter',
    'updateCustomFilter',
    'deleteCustomFilter',
    'customFilters',
    'PermissionScheme',
    'JiraIssue',
    'projectStyle',
    'startSprintPrototype',
    'AddIssuesToFixVersion',
    'JiraVersionResult',
    'JiraIssueConnectionJql',
    'JiraFieldOptionSearching',
    'JiraIssueFieldMutations',
    'JiraIssueDevInfoDetails',
    'JiraIssueDevSummaryCache',
    'JiraVersionWarningConfig',
    'JiraReleaseNotesConfiguration',
    'JiraUpdateReleaseNotesConfiguration',
    'ReleaseNotes',
    'ReleaseNotesOptions',
    'DeploymentsFeaturePrecondition',
    'UpdateVersionWarningConfig',
    'UpdateVersionName',
    'UpdateVersionDescription',
    'UpdateVersionStartDate',
    'UpdateVersionReleaseDate',
    'VersionsForProject',
    'RelatedWork',
    'SuggestedRelatedWorkCategories',
    'setIssueMediaVisibility',
    'toggleBoardFeature',
    'DevOpsProvider',
    'DevOpsSummarisedDeployments',
    'JiraProject',
    'DevOpsSummarisedEntities',
    'RoadmapsMutation',
    'RoadmapsQuery',
    'JiraApplicationProperties',
    'JiraIssueSearch',
    'JiraFilter',
    'featureGroups',
    'setBoardEstimationType',
    'devOps',
    'softwareBoards',
    'name',
    'AddRelatedWorkToVersion',
    'RemoveRelatedWorkFromVersion',
    'admins',
    'canAdministerBoard',
    'jql',
    'globalCardCreateAdditionalFields',
    'GlobalTimeTrackingSettings',
    'ReleaseNotesOptions',
    'search-experience',
    'MoveOrRemoveIssuesToFixVersion',
    'compass-beta',
    'JiraIssueSearchStatus',
    'Townsquare',
    'JiraNavigationItems',
    'JiraVersionsForProjects',
    'columnConfigs'
];

});


parcelRegister("1b0Xp", function(module, exports) {

$parcel$export(module.exports, "default", () => $2912bf4fa2770fd6$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $4FhhO = parcelRequire("4FhhO");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$2912bf4fa2770fd6$export$2e2bcd8739ae039 = {
    cancel: ()=>{},
    schedule: (fn)=>{
        // react 16.x
        if (// `unstable_batchedUpdates` is defined in all currently supported versions
        // but could be removed in the future.
        // This check is defensive and not currently necessary.
        typeof (0, (/*@__PURE__*/$parcel$interopDefault($4FhhO))).unstable_batchedUpdates === 'function' && // The version export was only introduced in `react-dom@16.13.0`
        // but we need to support `react-dom@^16.8.0`
        // so we need to handle when the version is `undefined`
        (typeof (0, $4FhhO.version) === 'undefined' || (0, $4FhhO.version).startsWith('16'))) (0, (/*@__PURE__*/$parcel$interopDefault($4FhhO))).unstable_batchedUpdates(()=>{
            fn();
        });
        else if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).startTransition === 'function') // @ts-ignore-error React.startTransition does not exist in react-16
        (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).startTransition(()=>{
            fn();
        });
        else fn();
        return '';
    }
};

});




//# sourceMappingURL=ReadTimePopup.b9f2f457.js.map
